// extracted by mini-css-extract-plugin
export var avatarContainer = "_7g-0";
export var avatarTypingWave = "_7g-i";
export var gray = "_7g-f";
export var green = "_7g-c";
export var icon = "_7g-9";
export var image = "_7g-1";
export var lg = "_7g-6";
export var md = "_7g-5";
export var presenceDot = "_7g-b";
export var red = "_7g-d";
export var sm = "_7g-4";
export var status = "_7g-a";
export var typingDot = "_7g-h";
export var typingPill = "_7g-g";
export var xl = "_7g-7";
export var xs = "_7g-3";
export var xxl = "_7g-8";
export var xxs = "_7g-2";
export var yellow = "_7g-e";